<button
  class="med-table-head-cell"
  type="button"
  [ngClass]="classList"
  (click)="onSort()"
>
  <ng-container
    *ngIf="template; else defaultCell"
    [ngTemplateOutlet]="template"
    [ngTemplateOutletContext]="{ $implicit: column }"
  ></ng-container>

  <ng-template #defaultCell> {{ column.label }} </ng-template>

  <med-icon-triangle-down
    *ngIf="column.sortable"
    class="med-table-head-cell__icon"
    size="16px"
  ></med-icon-triangle-down>
</button>
